export default __webpack_public_path__ + "static/media/internet-shop.1e4cc775.PNG";